export const updateInterviews = "updateInterviews";
export const updateInterviewDataTable = 'updateInterviewDataTable'